import(/* webpackMode: "eager" */ "/tmp/8df0214ebd40fab/src/app/template.tsx");
